<template>
  <!-- 保存模块弹窗
      @author 王汝鹏
      @date 2019-11-06
  -->
  <div class="domain-save-dialog">
    <el-form ref="form"
             size="mini"
             label-width="60px"
             label-position="left"
             onsubmit="return false"
             :rules="rules"
             status-icon
             :model="form">
      <!-- 模块名称输入框 -->
      <el-form-item class="domain-name-input" 
                    label="组名称"
                    prop="name">
        <el-input v-model="domainName"></el-input>
      </el-form-item>
      <!-- 保存模块操作按钮 -->
      <el-form-item class="domain-oper-button">
        <el-button class="save-button" 
                   type="primary" 
                   @click="onSubmit">保存</el-button>
        <el-button class="cancel-button" 
                   @click="onCancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mixRiceIndexChild } from "@/mixins/rice_index/mix_rice_index_child.js";
export default {
  mixins: [ mixRiceIndexChild ],
  props: {
    // 模块名称
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    /** @name 校验模块名称
     *  @author 王汝鹏
     *  @version 2019-12-10
     */
    const validateDomainName = (_, value, callback) => {
      let domainIndex = this.domainList.findIndex(domain => value === this.domainManager(domain).getName());
      if (domainIndex !== -1) callback(new Error("已经存在同名模块"));
      else callback();
    }
    return {
      rules: {
        name: [
          { required:true, message:'请输入模块名称', trigger:'blur' },
          { validator:validateDomainName, trigger:'blur' }
        ]
      }
    }
  },
  computed: {
    // 表单model
    form () { 
      return { name:this.value }; 
    },
    // 模块名称计算
    domainName: {
      get() { return this.value },
      set(newValue) { this.$emit('input', newValue); }
    }
  },
  methods: {
    /** @name 提交保存模块操作
     *  @author 王汝鹏
     *  @version 2019-10-06
     */
    onSubmit() { this.$refs['form'].validate().then(() => this.$emit('submit')); },
    /** @name 取消保存模块操作
     *  @author 王汝鹏
     *  @version 2019-10-06
     */
    onCancel() { this.$emit('cancel'); }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Config/DomainSaveDialog.vue